<script>
  import { onMount } from 'svelte';
  import Icon from '@ui/pico/icon.svelte';

  import { formsGetter, sitesGetter } from '../../services';
  import SitesTable from './sites-table.svelte';
  import FormsTable from './forms-table.svelte';
  import Highlights from './highlights.svelte';
  import { goto } from '../../util';
  import { pages } from '../../config';
  import BreadcrumbNav from '../components/breadcrumb-nav.svelte';
  import { account, accountForms, accountSites, siteLookup } from '../../store';

  export let params;

  const returnSlug = '?from=account.dashboard';
  $: forms = params?.site
    ? $accountForms?.filter((a) => a?.sid === params.site)
    : $accountForms;
  $: sites = $accountSites;
  $: activeSite = params?.site;
  $: activeSiteInfo = $siteLookup[activeSite] || null;

  onMount(async () => {
    if ($account) {
      await Promise.all([formsGetter(), sitesGetter()]);
    }
  });

  function goToAddSite() {
    goto(pages.sites.add.url, returnSlug);
  }
  function goToAddForm() {
    if (activeSite) {
      goto(pages.forms.add.url, activeSite, returnSlug);
    } else {
      goto(pages.forms.add.url, returnSlug);
    }
  }
  function updateSite(ev) {
    params.site = ev.detail.sid;
    console.info(ev.detail.sid, params.site);
  }
</script>

<div class="nav">
  <BreadcrumbNav current="My Account" />
</div>

<Highlights />

{#if $account}
  <section>
    <hgroup>
      <h2 class="icon-title-btn" on:keydown={null} on:click={goToAddSite}>
        <Icon name="plus-circle" size={28} />
        <span>Sites</span>
      </h2>
      <h4>Exhaustive list of sites for this account</h4>
    </hgroup>
    <SitesTable
      {sites}
      mode="sites.list"
      sid={params.site}
      on:siteSwitched={updateSite}
    >
      <div slot="empty">
        No sites found for this account.
        <br />
        <a alt="Add first site" href={pages.sites.first.url}>
          Click here to add your first site
        </a>
      </div>
    </SitesTable>
  </section>
{/if}

<section>
  <hgroup>
    <h2 class="icon-title-btn" on:keydown={null} on:click={goToAddForm}>
      <Icon name="plus-circle" size={28} />
      <span>Forms</span>
    </h2>

    <!-- TODO: why does this logic only work backwards? -->
    {#if activeSite}
      <h4>
        Showing only forms from
        <strong>{activeSiteInfo?.domain}</strong>
      </h4>
    {:else}
      <h4>Exhaustive list of forms for this account</h4>
    {/if}
  </hgroup>
  <FormsTable {forms} siteCount={sites?.length}>
    <div slot="no-sites">
      You must first add a site before adding forms to a site.
      <br />
      <a alt="Add first site" href={pages.sites.first.url}>
        Click here to add your first site
      </a>
    </div>
    <div slot="empty">
      You have no forms for this account
      <br />
      <a alt="Add first site" href={pages.forms.add.url}>
        Click here to add a form
      </a>
    </div>
  </FormsTable>
</section>

<section>
  <hgroup>
    <h2>Powerups</h2>
    <h4>Coming soon</h4>
  </hgroup>
</section>

<style>
  section {
    border: solid thin var(--contrast);
    border-radius: 12px;
    padding: 2rem;
  }
</style>
